/**
 * 보스 팩(pack) 엔티티 관련 쿼리·뮤테이션.
 * pre-order/pack-management, signup/pack-management에서 재사용.
 */
import { gql } from "@apollo/client";

export const CREATE_PACK = gql`
  mutation CreatePack(
    $name: String!
    $category: String!
    $price: Float!
    $discountPrice: Float!
    $discountRate: Float!
    $userPrice: Float!
    $quantity: Int!
    $description: String!
    $saleEndTime: DateTime
    $isTomorrowReservationEnabled: Boolean
    $maxOrderQuantity: Int
    $cancelMessage: String
    $packItems: [String!]
  ) {
    createPack(
      name: $name
      category: $category
      price: $price
      discountPrice: $discountPrice
      discountRate: $discountRate
      userPrice: $userPrice
      quantity: $quantity
      description: $description
      saleEndTime: $saleEndTime
      isTomorrowReservationEnabled: $isTomorrowReservationEnabled
      maxOrderQuantity: $maxOrderQuantity
      cancelMessage: $cancelMessage
      packItems: $packItems
    ) {
      id
      name
      store {
        reserveTime
      }
    }
  }
`;

export const GET_PACK_BY_SELLER = gql`
  query GetPackBySeller {
    packBySeller {
      id
      name
      price
      category
      discountPrice
      discountRate
      userPrice
      quantity
      description
      isTomorrowReservationEnabled
      maxOrderQuantity
      cancelMessage
      packItems {
        id
        name
      }
    }
  }
`;
